export type Emirate = {
  Id: number;
  id?: number;
  TitleAr: string;
  titleAr?: string;
  TitleEn: string;
  titleEn?: string;
  IsActive?: boolean;
  ManhalCode: string | null;
  manhalCode?: string | null;
};

export type Area = {
  Id: number;
  id?: number;
  TitleAr: string;
  titleAr?: string;
  TitleEn: string;
  titleEn?: string;
  IsActive?: boolean;
  ZoneId?: number;
  ManhalCode: string | null;
  manhalCode?: string | null;
  ZoneManhalCode?: string | null;
};

export type Region = {
  Id: number;
  id?: number;
  TitleAr: string;
  titleAr?: string;
  TitleEn: string;
  titleEn?: string;
  IsActive?: boolean;
  EmirateId?: number;
  ManhalCode?: string | null;
  manhalCode?: string | null;
};

export type Zone = {
  Id: number;
  id?: number;
  TitleAr: string;
  titleAr?: string;
  TitleEn: string;
  titleEn?: string;
  IsActive?: boolean;
  RegionId?: number;
  ManhalCode: string | null;
  manhalCode?: string | null;
};

// Helper functions to support both old and new API formats
export const getId = (item: Region | Zone | Area): number => (item as any).id ?? (item as any).Id;
export const getTitleEn = (item: Region | Zone | Area): string => (item as any).titleEn ?? (item as any).TitleEn;
export const getTitleAr = (item: Region | Zone | Area): string => (item as any).titleAr ?? (item as any).TitleAr;
export const getManhalCode = (item: Region | Zone | Area): string | null =>
  (item as any).manhalCode ?? (item as any).ManhalCode ?? null;

export const isDubaiOrAbuDhabi = (emirateName?: string | null): boolean => {
  if (!emirateName) return false;
  const normalized = emirateName.trim().toLowerCase();
  return (
    normalized.includes('dubai') ||
    normalized.includes('abu dhabi') ||
    normalized.includes('al ain') ||
    normalized.includes('dhafra') ||
    normalized.includes('دبي') ||
    normalized.includes('أبو ظبي') ||
    normalized.includes('العين') ||
    normalized.includes('الظفرة')
  );
};

export type AddressValue = {
  emirateId?: number;
  areaId?: number;
  streetName?: string;
  houseNumber?: string;
  regionId?: number;
  zoneId?: number;
  plotId?: number | string | null;
  longitude?: number | null;
  latitude?: number | null;
  mainPlotId?: string | null;
  premisesPlotId?: string | null;
  emirateNameEn?: string | null;
  emirateNameAr?: string | null;
  areaNameEn?: string | null;
  areaNameAr?: string | null;
  regionNameEn?: string | null;
  regionNameAr?: string | null;
  zoneNameEn?: string | null;
  zoneNameAr?: string | null;
  municipalityNameEn?: string | null;
  municipalityNameAr?: string | null;
  fullAddressEn?: string | null;
  fullAddressAr?: string | null;
  emirateManhalCode?: string | null;
  regionManhalCode?: string | null;
  areaManhalCode?: string | null;
  zoneManhalCode?: string | null;
};
